import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { Link } from 'react-router-dom'
import styles from './empty-state-banner.module.scss'

interface Props {
  text: string
  subtext?: string
  link?: {
    href: string
    text: string
  }
}

export const EmptyStateBanner = ({ text, subtext, link }: Props) => {
  return (
    <div className={styles.container}>
      <FontAwesomeIcon className={styles.icon} icon={faInfoCircle} />
      <span className={styles.text}>
        <b>{text}</b> {subtext}{' '}
        {link && (
          <Link to={link?.href} className={styles.link}>
            {link.text}
          </Link>
        )}
      </span>
    </div>
  )
}
